export default {
  stepper: {
    description: 'Restaurant-onboarding',
    steps: {
      confirm_email: 'E-mailadres bevestigen',
      add_store_details: 'Voeg uw winkelgegevens toe',
      add_personal_details: 'Voeg uw persoonlijke gegevens toe',
      add_bank_details: 'Bankgegevens toevoegen voor uitbetalingen',
      add_tax_details: 'Is uw bedrijf btw-plichtig?',
      upload_business_doc: 'Bedrijfsbewijs',
      upload_personal_doc: 'Identiteitsbewijs',
      confirm_details: 'Uitbetaald worden',
    },
  },
  completed: {
    title: 'Onboarding voltooid',
    description:
      'Uw onboarding is voltooid. U kunt hier op elk moment documenten toevoegen, bijvoorbeeld de ID van een nieuwe partner of een vernieuwde ID.',
  },
  toasts: {
    failed_to_skip_verification_step: 'Verificatiestap overslaan mislukt. Probeer het opnieuw',
  },
};
